import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";

/**
 * Android system back: go to the previous in-app page; only leave the app from a root screen.
 * Without a "backButton" listener the shell falls back to the WebView's own history, which can
 * close the app when route changes were done with replace().
 */
const ROOT_PATHS = ["/", "/relax", "/splashscreen", "/delivery", "/delivery/login", "/delivery/home"];

const NativeBackButton = () => {
  const history = useHistory();
  const historyRef = useRef(history);
  historyRef.current = history;

  useEffect(() => {
    if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "android") return undefined;

    let handle;
    App.addListener("backButton", ({ canGoBack }) => {
      const h = historyRef.current;
      const atRoot = ROOT_PATHS.includes(h.location.pathname);
      if (!atRoot && (canGoBack || h.length > 1)) {
        h.goBack();
      } else if (!atRoot) {
        h.replace(h.location.pathname.startsWith("/delivery") ? "/delivery/home" : "/");
      } else {
        App.exitApp();
      }
    }).then((l) => {
      handle = l;
    });

    return () => {
      if (handle) handle.remove();
    };
  }, []);

  return null;
};

export default NativeBackButton;
